'use client';

import H2 from '@/components/typography/h2';
import OtherCaseItem from '@/components/ui/other-case-item';
import { Case } from '@/payload-types';
import Link from 'next/link';

interface OtherCasesListProps {
    cases: Case[];
}

export default function OtherCasesList({ cases }: OtherCasesListProps) {
    return (
        <div className="border-primary flex flex-col lg:border-b lg:px-5 lg:pb-10">
            <div className="mb-6 px-5 lg:mb-10 lg:px-0">
                <H2>Andere cases</H2>
            </div>
            {cases.map((item, index) => (
                <Link key={index} href={`/cases/${item.slug}`}>
                    <OtherCaseItem
                        title={item.titel}
                        client={item.algemeneInformatie.klant}
                        services={item.algemeneInformatie.diensten.map((d) =>
                            typeof d.dienst === 'string'
                                ? d.dienst
                                : d.dienst.naam,
                        )}
                        year={item.algemeneInformatie.jaar}
                    />
                </Link>
            ))}
        </div>
    );
}
